var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},_vm._l((_vm.items),function(itemVal,key){return _c('div',{key:key,staticClass:"item"},[_c('b',[_vm._v(" "+_vm._s(key)+" ")]),_vm._v(" : "+_vm._s(itemVal)+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }